export default "__VITE_ASSET__CMiuQpB___"